import crews from "csi/access/crews";
import csiAction from "csi/action";
import Action from "csi/def/Action";
import { Context } from "csi/def/Context";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import _ from "lodash";
import OwnershipTypeRenderer from "src/Apparel/OwnershipTypeRenderer";

const StyleBOMOwnershipTypeRenderer = declare(OwnershipTypeRenderer, {

	linkedToMaterialPlan: false,
	/**
     * @override
     */
	canToggle(ctx: Context): boolean {
		return !xml.nodeIsFrozen(ctx.cache.getNode(ctx.getContextNode().CurrentRevision, true)) && 
            crews.isInRoles(["Product Specification Administrator", "TDS - BOM Administrator"], ctx.getContextNode());
	},

	/**
     * @override
     * Call unlink action is Style BOM is linked to Theme BOM
     */
	onToggle(ctx: Context, refNode: HTMLElement): void {
		const action = _.extend(new Action(), {
			m_id: this.linkedToMaterialPlan ? "UnlinkFromTheme" : "UnlinkStyleBOMFromThemeBOM",
			classController: "Apparel.UnlinkStyleBOMController",
			m_postAction: "postActionRefreshNode",
		});
		action.resolve();
		csiAction.invoke(ctx.view, refNode, action);
	},

	/**
     * @override
     * Display "Linked" if the Style BOM is linked to a Theme BOM or Material Plan
     */
	getOwnershipType(ctx: Context): string {
		this.linkedToMaterialPlan = ctx.getNode()?.LinkedToMaterialPlan;

		return xml.isValidURL(ctx.getNode()?.StyleBOMLinkedThemeBOM) || ctx.getNode()?.LinkedToMaterialPlan
			? this.OWNERSHIP_TYPE_LINKED : this.OWNERSHIP_TYPE_OWNED;
	},

	/**
     * @override
     */
	shouldDisplayToggle(ctx: Context): boolean {
		return (xml.isValidURL(ctx.getNode()?.StyleBOMLinkedThemeBOM) || ctx.getNode()?.LinkedToMaterialPlan) && !ctx.view.bPopup;
	},
});

export = StyleBOMOwnershipTypeRenderer;
